import { useEffect, useState } from "react";
import { MediaService } from "@/services/media/mediaService";

/**
 * Resolves FULL_SIZE download URL for news images (card backgrounds, popups).
 * Falls back to the provided preview URL when resolution fails.
 */
export function useNewsFullSizeImage(
  mediaId: string | undefined,
  fallbackUrl: string | undefined,
): string | undefined {
  const [url, setUrl] = useState<string | undefined>(fallbackUrl);

  useEffect(() => {
    if (!mediaId) {
      setUrl(fallbackUrl);
      return;
    }

    let cancelled = false;

    MediaService.getDownloadUrl(mediaId, 3600, true)
      .then((fullUrl) => {
        if (!cancelled && fullUrl) setUrl(fullUrl);
      })
      .catch(() => {
        if (!cancelled) setUrl(fallbackUrl);
      });

    return () => {
      cancelled = true;
    };
  }, [mediaId, fallbackUrl]);

  return url;
}
